import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../homePageComp/Footer";
import issueData from "./issueData";
import Card from "./Card";

function Latest() {
  useEffect(() => {
    document.title = "AJORIST - Latest";
  }, []);
  return (
    <React.Fragment>
      <Header />
      <main className="py-12 sm:py-16 bg-sky-50/75">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h1 className="text-3xl sm:text-4xl font-bold text-sky-900 tracking-tight">
              Volume 1, Issue 1
            </h1>
            <p className="mt-2 text-lg text-slate-600">
              The latest articles from AJORIST.
            </p>
          </div>
          <div className="flex flex-col items-center gap-6 sm:gap-8">
            {issueData.map((val, key) => {
              return <Card key={key} data={val} />;
            })}
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export default Latest;
